/**
 * Coups de pouce — Attendu 1073 « Savoir qu'un angle droit mesure 90°, qu'un
 * angle plat mesure 180° ».
 *
 * figure_saisie : lire l'alignement (180°) et le petit carré (90°), déduire
 * l'autre angle droit de l'angle plat (question c. de la fiche, sans
 * rapporteur). SVG pas à pas piloté par les flèches de la sheet
 * (data-etapes / data-caption).
 *
 * Sans coup de pouce (pur rappel) : mesures_saisie, mesures_fraction_qcm_unique,
 * vf_tableau_vf.
 */

const SVG_FIGURE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 250" width="100%" style="max-width:380px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Angle plat et angle droit sur une figure, en 3 étapes à faire défiler avec les flèches. Les points P, O, Q sont alignés et la demi-droite OR est perpendiculaire à PQ, avec un petit carré entre OP et OR. Étape 2 : P, O, Q alignés donc PÔQ mesure 180 degrés, c'est un angle plat ; le petit carré dit que PÔR mesure 90 degrés. Étape 3 : PÔR et RÔQ forment l'angle plat PÔQ, donc RÔQ mesure 180 moins 90, soit 90 degrés. Alignés : 180 degrés. Petit carré : 90 degrés. Le reste : 180 moins 90">
  <style>
    @keyframes cp1073-pop { from { opacity: 0; } to { opacity: 1; } }
    .cp1073-pop { opacity: 0; animation: cp1073-pop 0.5s ease forwards; }
  </style>
  <!-- sous-titres : un par étape (exclusifs, pilotés par la sheet) -->
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1E3A8A" opacity="1" data-caption="1" font-family="system-ui,sans-serif">P, O, Q alignés ; (OR) perpendiculaire à (PQ)</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#B45309" opacity="0" data-caption="2" font-family="system-ui,sans-serif">Alignés : PÔQ = 180°. Petit carré : PÔR = 90°</text>
  <text x="8" y="21" font-size="12.5" font-weight="600" fill="#1D9E75" opacity="0" data-caption="3" font-family="system-ui,sans-serif">Il reste RÔQ = 180 − 90 = 90°</text>

  <!-- ── La figure (étape 1) ─────────────────────────────────────────── -->
  <g data-etape="1" font-family="system-ui,sans-serif">
    <line x1="92.0" y1="138.0" x2="20.7" y2="148.0" stroke="#1E3A8A" stroke-width="2.2"/><text x="7.8" y="154.8" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">P</text><line x1="92.0" y1="138.0" x2="163.3" y2="128.0" stroke="#1E3A8A" stroke-width="2.2"/><text x="176.2" y="131.2" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">Q</text><line x1="92.0" y1="138.0" x2="82.0" y2="66.7" stroke="#1E3A8A" stroke-width="2.2"/><text x="80.2" y="58.8" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">R</text>
    <polyline points="90.3,126.1 78.4,127.8 80.1,139.7" fill="none" stroke="#111827" stroke-width="1.8"/>
    <circle cx="92.0" cy="138.0" r="2.6" fill="#1e293b"/>
    <text x="94.2" y="158.8" font-size="13" font-weight="700" fill="#1e293b" text-anchor="middle">O</text>
  </g>

  <!-- ── L'angle plat et l'angle codé (étape 2) ──────────────────────── -->
  <g data-etape="2" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1073-pop">
      <path d="M 131.6 132.4 A 40 40 0 0 0 52.4 143.6" fill="none" stroke="#B45309" stroke-width="2" stroke-dasharray="5 3"/>
      <text x="84.5" y="88.5" font-size="12" font-weight="700" fill="#B45309" text-anchor="middle">180°</text>
      <polyline points="90.3,126.1 78.4,127.8 80.1,139.7" fill="none" stroke="#B45309" stroke-width="2.8"/>
      <text x="71.2" y="126.4" font-size="11" font-weight="700" fill="#B45309" text-anchor="middle">90°</text>
      <text x="192" y="72" font-size="12" font-weight="700" fill="#B45309">P, O, Q alignés :</text>
      <text x="192" y="87" font-size="12" font-weight="700" fill="#B45309">PÔQ = 180°, angle plat.</text>
      <text x="192" y="111" font-size="12" font-weight="700" fill="#B45309">Le petit carré dit :</text>
      <text x="192" y="126" font-size="12" font-weight="700" fill="#B45309">PÔR = 90°, angle droit.</text>
    </g>
  </g>

  <!-- ── L'autre angle (étape 3) ─────────────────────────────────────── -->
  <g data-etape="3" data-anim="1" font-family="system-ui,sans-serif">
    <g class="cp1073-pop">
      <path d="M 92.0 138.0 L 121.7 133.8 A 30 30 0 0 0 87.8 108.3 Z" fill="#a7f3d0" fill-opacity="0.7" stroke="#1D9E75" stroke-width="1.6"/>
      <polyline points="103.9,136.3 102.2,124.4 90.3,126.1" fill="none" stroke="#1D9E75" stroke-width="2" stroke-dasharray="3 2"/>
      <text x="119.7" y="105.3" font-size="11" font-weight="700" fill="#1D9E75" text-anchor="middle">90°</text>
      <text x="192" y="156" font-size="12" font-weight="700" fill="#1D9E75">PÔR et RÔQ forment</text>
      <text x="192" y="171" font-size="12" font-weight="700" fill="#1D9E75">l'angle plat PÔQ :</text>
      <text x="192" y="190" font-size="13" font-weight="800" fill="#1D9E75">RÔQ = 180 − 90 = 90°</text>
      <text x="192" y="208" font-size="11" font-weight="600" fill="#1e293b">(sans rapporteur : on lit la figure)</text>
      <text x="180" y="243" font-size="12" font-weight="800" fill="#1E3A8A" text-anchor="middle">Alignés : 180°. Petit carré : 90°. Le reste : 180 − 90.</text>
    </g>
  </g>

  <text x="180" y="246" font-size="11" font-weight="700" fill="#b45309" text-anchor="middle" opacity="0" data-caption="1" font-family="system-ui,sans-serif">↓ Touche les flèches pour avancer, étape par étape ↓</text>
</svg>`.trim();

const AIDE_FIGURE = {
    pages: [
        {
            titre: 'La règle',
            lignes: [
                '**Trois points alignés font un angle plat : 180°.** A, O, B alignés, donc AÔB = 180°.',
                '**Le petit carré dit « angle droit » : 90°.**',
                "**De l'autre côté de la perpendiculaire, c'est aussi 90°** : les deux angles forment l'angle plat, 180 − 90 = 90.",
                "**On ne mesure pas avec le rapporteur** : on lit l'alignement et le petit carré.",
            ],
        },
        { titre: 'Un exemple', svg: SVG_FIGURE },
    ],
};

const CP_1073 = {
    figure_saisie: AIDE_FIGURE,
};

export default CP_1073;
